module.exports = __webpack_public_path__ + "img/portrait-020.90f3dad1.jpg";